<advanced-filter (onSubmit)="applyFilter()" *ngIf="isCoLogin()"></advanced-filter>
<app-spinner-overlay [showSpinner]="loading"></app-spinner-overlay>
<wl-card heading="{{heading}} ({{totalCount}})" subheading1="{{subheading1}}" subheading2="{{subheading2}}" *ngIf="showRenewalDataTable">

  <!-- <input type="month" id="start" name="start" min="2022-01" [max]="maxDate" [(ngModel)]="currentDate" #date1 style="
    height: 35px;
      border-color: rgb(223, 223, 223);
      box-shadow: 0 2px 3px 0 rgba(179, 179, 179, 0.2), 0 3px rgba(177, 177, 177, 0.19);
      border-radius: 4px;
      border-left: 0px solid rgb(223, 223, 223);
      border-right: 0px solid rgb(223, 223, 223); 
      border-top: 1px solid rgb(236, 236, 236); 
      border-bottom: 0px solid rgb(223, 223, 223);
    ">
  <input type="month" id="end" name="ends" min="2022-01" [max]="maxDate" [(ngModel)]="currentDate" #date2 class="display-none">

  <button class="ml-10px mybutton" (click)="submitDates()">Submit</button> -->

  <wl-date-input (dateRangeSelected)="onDateRangeSelected($event)" *ngIf="!isCoLogin()"></wl-date-input>

  <span *ngIf="showSelectedDate && !isCoLogin()" class="datetext">&nbsp;&nbsp;{{selectedDate}}&nbsp;&nbsp;      <img src="../../../assets/fontawesome-web/svgs/regular/rectangle-xmark.svg" class="h-15px" (click)="closeButtonClick()">
  </span>


  <!-- <div>
    <mat-form-field class="w-full">
      <input type="text" matInput placeholder="{{searchHolder}}" (input)="onSearchClick($event)" [formControl]="search"><img
        class="ml-neg30px-important" src="../../../assets/svg/search.svg">
    </mat-form-field>
  </div> -->
  <wl-search-input (searchValueChanged)="onSearch($event)" [ngClass]="{'search': isCoLogin()}"></wl-search-input>
  <br>

  <p *ngIf="noUserFound" class="m-100px text-center font-size-15em">{{noUserFound}}</p>

  <div *ngIf="!noUserFound" child-container class="table-responsive">
    <table class="table table-hover">
      <thead>
        <tr>
          <th class="w-60px">Sr. No.</th>
          <th>CIF ID</th>
          <th>Name</th>
          <th>Acc. No.</th>
          <!-- <th *ngIf="makerOnly && showPending" class="ml-20px">&nbsp;&nbsp;&nbsp;Send SMS</th> -->
          <th *ngIf="showFilter1">Due date <br> of Renewal</th>
          <th *ngIf="showFilter1">Date of <br>Sent to CBS</th>
          <th *ngIf="showFilter1">CBS <br>Status</th>
          <th *ngIf="showFilter3 || showFilter2" class="text-left">Existing <br>DP</th>
          <th *ngIf="showFilter3 || showFilter2" class="text-left">Proposed <br>DP</th>

          <!-- <th *ngIf="showFilter1 || showFilter2" class="text-center">Consent Date</th> -->
          <th *ngIf="showFilter1 || showFilter2" class="text-center">Actions</th>
          <th *ngIf="showFilter3" class="text-left">Basis</th>
        </tr>
      </thead>

      <tbody>
        <tr *ngFor="let user of allUsers;let i = index;">



          <td class="vertical-align-middle">{{10 *(pageId-1)+i+1}}</td>

          <td class="vertical-align-middle">{{user.custId}}</td>
          <td class="vertical-align-middle w-16pct">{{user.profile.name}}</td>
          <td class="vertical-align-middle">{{user?.user_docs?.kcc_acc_no_unMasked}}</td>
          <!-- <td *ngIf="makerOnly && showPending">
            <wl-button-nolabel (click)="sendSms(user.id)">SMS</wl-button-nolabel>

          </td> -->
          <td *ngIf="showFilter1" class="vertical-align-middle">
            {{user?.user_docs?.renewal_duedate_for_credit_limit}}
          </td>
          <!-- <td *ngIf="showFilter1" class="vertical-align-middle">{{user?.sent_to_cbs_date}}</td> -->
          <td *ngIf="showFilter1" class="vertical-align-middle">{{get_cbs_date(i)}}</td>
          <td *ngIf="showFilter1" class="vertical-align-middle">{{user?.cbs_auto_renewal_status=="A"?"Approved":"Pending"}}</td>

          <td *ngIf="showFilter3 || showFilter2" class="vertical-align-middle"><p>{{user?.user_docs?.existing_dp}}</p></td>
          <td *ngIf="showFilter3 || showFilter2"><p>{{user?.final_form_submitted_data?.proposed_dp_k?user?.final_form_submitted_data?.proposed_dp_k:"Not available"}}</p></td>


          <!-- <td class="text-center" *ngIf="showFilter1 || showFilter2">
            20-04-2022
          </td> -->

          <td class="text-center" *ngIf="showFilter1 || showFilter2">
            <p>
            <a *ngIf="showFilter1" class="text-no-decoration cursor-pointer" color="primary" target="_blank" color="primary"
              (click)="View(user.id)">
              View</a> <span *ngIf="showFilter1">&nbsp;&nbsp;|&nbsp;&nbsp;</span>
            <a *ngIf="(showFilter1) && !user.sent_to_cbs" class="text-no-decoration cursor-pointer" color="primary" target="_blank" color="primary"
              (click)="sendToCbs(user?.custId, user?.profile?.name, user?.user_docs?.kcc_acc_no_unMasked, i)">
               Send to CBS </a>
            </p>

            <p>
            <a *ngIf="showFilter2" class="text-no-decoration cursor-pointer" color="primary" target="_blank" color="primary"
              (click)="View(user.id)">
              Reassess</a> <span *ngIf="showFilter2">&nbsp;&nbsp;|&nbsp;&nbsp;</span>
            <a *ngIf="showFilter2" class="text-no-decoration cursor-pointer" color="primary" target="_blank" color="primary"
              (click)="reject(user.id)">
               Reject </a>

          </td>
          <td *ngIf="showFilter3" class="text-left"><p>{{checkTheBasis(i)}}</p></td>
        </tr>
      </tbody>
    </table>
  </div>

  <nav class="flex-center" *ngIf="totalPage>1" aria-label="Page navigation example">
    <ul class="pagination">

      <li *ngIf="page>3"><a (click)="getAllUsersPage(filter,roleId,offset - 10,10,page - 1)">Previous</a></li>
      <li *ngIf="page>2"><a (click)="getAllUsersPage(filter,roleId,offset - 20,10,page - 2)">{{page - 2}}</a></li>
      <li *ngIf="page>1"><a (click)="getAllUsersPage(filter,roleId,offset - 10,10,page - 1)">{{page - 1}}</a></li>
      <li class="page-item active"><a (click)="getAllUsersPage(filter,roleId,offset,10,page)">{{page}}</a></li>
      <li *ngIf="page<totalPage"><a (click)="getAllUsersPage(filter,roleId,offset + 10,10,page + 1)">{{page + 1}}</a></li>
      <li *ngIf="page+1<totalPage"><a (click)="getAllUsersPage(filter,roleId,offset + 20,10,page + 2)">{{page + 2}}</a></li>
      <li *ngIf="page<totalPage"><a (click)="getAllUsersPage(filter,roleId,offset + 10,10,page + 1)">Next</a></li>
    </ul>
  </nav>


</wl-card>





<link rel="stylesheet" href="https://pro.fontawesome.com/releases/v5.10.0/css/all.css"
  integrity="sha384-AYmEC3Yw5cVb3ZcuHtOA93w35dYTsvhLPVnYs9eStHfGJvOvKxVfELGroGkvsg+p" crossorigin="anonymous" />
<!-- <link rel="stylesheet" href="https://maxcdn.bootstrapcdn.com/bootstrap/3.3.7/css/bootstrap.min.css"> -->